import { account } from './account.js';
import { profiles } from './profiles.js';

/* Canjear en la web (con cuenta) un código de invitación creado en una app de Android o Windows. El proveedor se guarda en la cuenta
   como solo lectura (sin enseñar ni editar sus datos) y conserva el permiso del invitado: así el dueño puede revocarlo y, si el
   proveedor se llena, manda el dueño (aviso de reproducción a /api/share-beat). */

export const inviteWeb = {
    async redeem(code, label) {
        const r = await account.request('POST', '/api/share-invites/redeem', { auth: false, body: { code, label: label || '' } });
        const p = r.profile || {};
        return profiles.add({
            type: p.type || 'xtream', name: p.name || '', host: p.host || '', username: p.username || '', password: p.password || '', m3uUrl: p.m3uUrl || '', epgUrl: p.epgUrl || '',
            sharedBy: p.by || '', invite: { id: r.inviteId, grantId: r.grantId, secret: r.grantSecret }
        });
    }
};

/** Aviso de reproducción de un proveedor canjeado por código (lo usa shared-use.js). */
export const inviteWebBeat = {
    applies: (p) => !!(p && p.viaCode && p.invite),
    async beat(profile, { sid, max, stop }) {
        try {
            return await account.request('POST', '/api/share-beat', { auth: false, timeout: 8000, body: { id: profile.invite.id, secret: profile.invite.secret, grantId: profile.invite.grantId, sessionId: sid, max, stop: !!stop } });
        } catch (e) {
            if (e && e.status === 410) { await profiles.remove(profile.id).catch(() => {}); return { revoked: true }; } // el dueño dejó de compartirlo
            return {};
        }
    }
};
